import * as React from "react";

import { RouterTextLink } from "components/actions/RouterLink";
import { appRoutes } from "lib/appRoutes";
import { useCheckSubscription } from "lib/providers/ProHelper";
import MultipleEntityLinks from "./MultipleEntityLinks";

import css from "./SuppliersContainer.module.scss";

type Supplier = {
  guid: string;
  name: string;
};

type Props = {
  recordName: string;
  suppliers: Supplier[];
  ellipsis?: boolean;
};

export default function SuppliersContainer({
  recordName,
  suppliers,
  ellipsis = false,
}: Props): JSX.Element | null {
  const { authorised, checkSubscription } = useCheckSubscription("SUPPLIERS", {
    "Context source": "In-row",
  });
  const supplierLinks = React.useMemo(() => {
    if (!suppliers) return null;

    const uniqueSuppliers: Supplier[] = [];
    suppliers.forEach((s) => {
      // This dedupes the suppliers in case there are some that are in multiple lots
      if (!uniqueSuppliers.some((us) => us.guid === s.guid)) uniqueSuppliers.push(s);
    });

    return uniqueSuppliers.map((s) => (
      <RouterTextLink
        {...appRoutes.supplierDetail(s.guid)}
        authorised={authorised}
        onUnauthorisedClick={(e) => {
          e.stopPropagation();
          checkSubscription();
        }}
        key={s.guid}
        className={ellipsis ? css.ellipsis : undefined}
      >
        <b>{s.name}</b>
      </RouterTextLink>
    ));
  }, [authorised, checkSubscription, suppliers, ellipsis]);

  return supplierLinks ? (
    <MultipleEntityLinks title={`Suppliers for "${recordName}"`} links={supplierLinks} />
  ) : null;
}
